import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { createBlog } from '../../redux/blog/blogSlice';
import type { AppDispatch } from '../../redux/';
import type { BlogPost } from '../../types/blog';

const useCreateBlog = () => {
  const dispatch = useDispatch<AppDispatch>();

  /**
   * Creates a blog post and returns the created record, or null on failure.
   *
   * Callers need the new record's id so that follow-up saves can update it
   * instead of creating a second post — hence a record rather than a boolean.
   */
  const handleCreateBlog = useCallback(
    async (blogData: BlogPost): Promise<BlogPost | null> => {
      try {
        const created = await dispatch(createBlog(blogData)).unwrap();
        return created ?? null;
      } catch (error) {
        console.error('Failed to create blog:', error);
        return null;
      }
    },
    [dispatch]
  );

  return { createBlog: handleCreateBlog };
};

export default useCreateBlog;
